import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'scroll-to-top',
  templateUrl: 'scroll-to-top.component.html',
  styleUrls: ['scroll-to-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatMiniFabButton, MatIcon],
})
export class ScrollToTopComponent {
  readonly scrollToTop = output<void>();

  onScrollToTop(): void {
    this.scrollToTop.emit();
  }
}
